// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__7606X","head":"ProcedureTableInfo_head__emDaU"};